<template>

   <div class="container">
       <div class="title">Offres d'emploi</div>
       <div class="highlighted topPage">Envie de rejoindre la 🦄 Française des solutions digitales agricoles ? </div>

    
        <div class="top mb-5">
            <p><strong>Ce qui nous anime ? : La technologie au service de la performance agricole !</strong></p>

            <p>Agrivitech est forte d'une expertise technique solide et d'un réseau de clients et partenaires leaders dans leur secteur, ce qui fait en fait une société en pointe de la digitalisation du monde agricole.</p>
            <p>Nous sommes un acteur de la 3ème révolution agricole : agriculture de précision et valorisation des données.</p>

            <p class="backGreen"><strong>Notre mission</strong> : améliorer la performance des entreprises du secteur agricole au travers de la digitalisation de leurs processus, tout en contribuant à la réduction de leur empreinte carbone.</p>

            <p>
                Nos clients sont les coopératives et négoces agricoles, pour lesquels nous avons développé 3 solutions complémentaires :
                <ul>
                    <li><strong>NovaFerme</strong> : une solution digitale regroupant l'activité de vente d'approvisionnements agricoles avec l'activité de collecte de céréales dans une même plateforme web et mobile.</li>
                    <li><strong>Fleet</strong> : un algorithme optimisant automatiquement les tournées de livraison de nos clients, couplé à une application mobile utilisée par les livreurs.</li>
                    <li><strong>Echange Agris</strong> : la plateforme permettant aux agriculteurs d'une même région de s'échanger entre eux les appros agricoles qu'ils n'utilisent pas : le maillons circulaire de la chaine d'appro logistique.</li>
                </ul>
            </p>
            
            <p>Chez AgriVitech nous sommes tous passionnés de technologie : applications web et mobile, UX, Web 3.0, AI, AR, data et algorithmes sont au cœur de notre activité et de notre expertise.</p>

            <p>Si vous partagez cette passion et souhaitez contribuer à l'agriculture 3.0 vous devriez trouver avec nous de quoi alimenter votre ambition !</p>
            
            <p>
                Notre équipe est pour l'heure constituée de 10 personnes et basée au Village by CA de Reims. <br>
                Et chez nous, pas de baby foot, mais des compétitions de Beat Saber !
            </p>
        </div>
                        

        <div class="row">
            <div class="col-md-3">
                <div class="highlighted menu">Offres :</div>
                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a class="nav-link active" id="v-pills-devfront-tab" data-toggle="pill" href="#v-pills-devfront" role="tab" aria-controls="v-pills-devfront" aria-selected="true"><i class="fas fa-code"></i> Développeur Front</a>
                    <a class="nav-link" id="v-pills-devback-tab" data-toggle="pill" href="#v-pills-devback" role="tab" aria-controls="v-pills-devback" aria-selected="false"><i class="fas fa-code"></i> Développeur Back</a>
                    <!-- <a class="nav-link " id="v-pills-chefprojet-tab" data-toggle="pill" href="#v-pills-chefprojet" role="tab" aria-controls="v-pills-chefprojet" aria-selected="false"><i class="fas fa-star"></i> Chef de projets</a> -->
                    <a class="nav-link" id="v-pills-datasc-tab" data-toggle="pill" href="#v-pills-datasc" role="tab" aria-controls="v-pills-datasc" aria-selected="false"><i class="fas fa-database"></i> Data Scientist</a>
                    <a class="nav-link" id="v-pills-support-tab" data-toggle="pill" href="#v-pills-support" role="tab" aria-controls="v-pills-support" aria-selected="false"><i class="fas fa-star"></i> Support technique </a>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="v-pills-tabContent">


                    <div class="tab-pane fade active show" id="v-pills-devfront" role="tabpanel" aria-labelledby="v-pills-devfront-tab">
                        <div class="card">

                            <h2 class="title">Développeur Front</h2>
                            <div class="intro">
                                <div><i class="fas fa-user-ninja bleu mr-2"></i>Design, Développement</div>
                                <div><i class="fas fa-map-signs bleu mr-2"></i>Bezannes</div>
                                <div><i class="fas fa-clock bleu mr-2"></i>Télétravail partiel</div>
                                <div><i class="fas fa-graduation-cap bleu mr-2"></i>Contrat d'apprentissage, Contrat de professionnalisation <br> à partir de septembre 2023 <br> pour une durée de 1 an , 18 mois, 2 ans</div>
                            </div>                        
                            
                            <h4 class="highlighted">Profil recherché</h4>
                            
                            <h4>Développeur front REACT</h4>

                            <p>Nous recherchons un développeur front, plus spécifiquement REACT, mais un profil expérimenté dans un autre framework JS (comme Vue) peut matcher 🥷.</p>

                            <p>Votre grande qualité sera votre capacité à utiliser REACT au delà d'un simple HTML / CSS pour développer des pages. Nous recherchons des personnes à l'aise avec la conception, la manipulation de données, l'algorithmie qui saurons exploiter le framework pour développer des fonctionnalités performantes et robustes.</p>

                            <p>Vous devrez aussi avoir une fibre pour l'expérience utilisateurs et le design. <br>
                            Nous ne cherchons pas un designer graphique, mais une personne sensible à l'expérience que vivront ses utilisateurs.</p>

                            <p>Nous recherchons des alternants ou contrats pro : vous vous ferez une réelle place dans notre équipe, et nous aurons à coeur de vous accompagner dans votre parcours d'alternance.</p>

                            <a href="mailto:rh@agrivitech.com" class="btn btn-secondary m-5">Postuler</a>
                        </div>
                    </div>


                    <div class="tab-pane fade" id="v-pills-devback" role="tabpanel" aria-labelledby="v-pills-devback-tab">
                        <div class="card">

                            <h2 class="title">Développeur Back</h2>
                            <div class="intro">
                                <div><i class="fas fa-user-ninja bleu mr-2"></i>Algorithmie, Conception, Développement</div>
                                <div><i class="fas fa-map bleu mr-2"></i>Bezannes</div>
                                <div><i class="fas fa-clock bleu mr-2"></i>Télétravail partiel</div>
                                <div><i class="fas fa-graduation-cap bleu mr-2"></i> Contrat d'apprentissage, Contrat de professionnalisation <br> à partir de septembre 2023 <br> pour une durée de 1 an , 18 mois, 2 ans</div>
                            </div>
                            
                            <h4 class="highlighted">Profil recherché</h4>
                            
                            <h4>Développeur Back : NodeJS, MySql</h4>

                            <p>Nous recherchons un développeur back pour travailler avec nous sur nos applicatifs serveur (API NodeJS, BDD MySQL, automatisation de tâches, etc...) 🥷.</p>

                            <p>Vous serez amenés à intervenir sur notre propres API (destinés à un usage interne ou à destination de nos clients), comme sur l'intégration d'API externes (ex : API EuroNext).</p>

                            <p>Nous recherchons des alternants ou contrats pro : vous vous ferez une réelle place dans notre équipe, et nous aurons à coeur de vous accompagner dans votre parcours d'alternance.</p>

                            <a href="mailto:rh@agrivitech.com" class="btn btn-secondary m-5">Postuler</a>
                        </div>
                    </div>


                    <div class="tab-pane fade  " id="v-pills-chefprojet" role="tabpanel" aria-labelledby="v-pills-chefprojet-tab">
                        <div class="card">

                            <h2 class="title">Chef de projet</h2>
                            <div class="intro">
                                <div><i class="fas fa-star bleu mr-2"></i>Organisation, planning, relationnel</div>
                                <div><i class="fas fa-map bleu mr-2"></i>Bezannes</div>
                                <div><i class="fas fa-clock bleu mr-2"></i>Télétravail partiel</div>
                                <div><i class="fas fa-graduation-cap bleu mr-2"></i> Contrat d'apprentissage, Contrat de professionnalisation <br> à partir de maintenant <br> pour une durée de 1 an , 18 mois, 2 ans</div>
                            </div>
                            
                            <h4 class="highlighted">Profil recherché</h4>
                            
                            <h4>Chef de projet tech</h4>

                            <p>Nous cherchons un alternant en gestion de projet qui aura pour mission principale de travailler avec nos clients sur les projets d'intégration de nos solutions.</p>

                            <p>Pour cela vous serez en relation directe avec les équipes de nos clients et nos équipes techniques.</p>

                            <div class="mb-3">Vous assurerez : 
                                <li>le suivi du planning et de l'avancée des projets</li>
                                <li>le reporting aux différents membres du projet (tech, métier, direction)</li>
                                <li>la communication interne des projets</li>
                            </div>

                            <p>Aussi, vous participerez aux réunions techniques et produits avec notre équipe R&D.</p>

                            <p>Nous recherchons des alternants ou contrats pro : vous vous ferez une réelle place dans notre équipe, et nous aurons à coeur de vous accompagner dans votre parcours d'alternance.</p>

                            <a href="mailto:rh@agrivitech.com" class="btn btn-secondary m-5">Postuler</a>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="v-pills-datasc" role="tabpanel" aria-labelledby="v-pills-datasc-tab">
                        <div class="card">

                            <h2 class="title">Data Scientist</h2>
                            <div class="intro">
                                <div><i class="fas fa-user-ninja bleu mr-2"></i>Algorithmie, Analyse de données, Reporting</div>
                                <div><i class="fas fa-map bleu mr-2"></i>Bezannes</div>
                                <div><i class="fas fa-clock bleu mr-2"></i>Télétravail partiel</div>
                                <div><i class="fas fa-graduation-cap bleu mr-2"></i> Contrat d'apprentissage, Contrat de professionnalisation <br> à partir de maintenant <br> pour une durée de 1 an , 18 mois, 2 ans</div>
                            </div>
                            
                            <h4 class="highlighted">Profil recherché</h4>
                            
                            <h4>Data Scientist</h4>

                            <p>Nous recherchons un Data Scientist qui aura pour mission d’analyser des données brutes collectées via nos solutions pour en améliorer la performance et construire de nouvelles fonctionnalités.</p>

                            <p>Vous travaillerez en étroite collaboration avec notre équipe R&D sur nos outils logistiques et sur l'analyse des profils de nos utilisateurs agriculteurs. <br>
                            Vous analyserez le comportement des utilisateurs de nos solutions et vous nous aiderez à les anticiper.</p>

                            <p>Nous recherchons des alternants ou contrats pro : vous vous ferez une réelle place dans notre équipe, et nous aurons à coeur de vous accompagner dans votre parcours d'alternance.</p>

                            <a href="mailto:rh@agrivitech.com" class="btn btn-secondary m-5">Postuler</a>
                        </div>
                    </div>

                    <div class="tab-pane fade" id="v-pills-support" role="tabpanel" aria-labelledby="v-pills-support-tab">
                        <div class="card">

                            <h2 class="title">Responsable support technique</h2>
                            <div class="intro">
                                <div><i class="fas fa-user-ninja bleu mr-2"></i>Développement, service client, reporting</div>
                                <div><i class="fas fa-map bleu mr-2"></i>Bezannes</div>
                                <div><i class="fas fa-clock bleu mr-2"></i>Télétravail partiel</div>
                                <div><i class="fas fa-graduation-cap bleu mr-2"></i> Contrat d'apprentissage, Contrat de professionnalisation <br> à partir de maintenant <br> pour une durée de 1 an , 18 mois, 2 ans</div>
                            </div>
                            
                            <h4 class="highlighted">Profil recherché</h4>
                            
                            <h4>Responsable support technique</h4>

                            <p><b>Mission :</b></p>

                           <p>En tant que Responsable Support Technique, vous serez le point d'échange privilégié pour nos clients sur tous les sujets techniques. Vous serez responsable de la gestion des canaux du support (Jira et Discord), de la réponse aux clients, de la résolution des anomalies, de la mise à jour des tickets et de l'alimentation du reporting hebdomadaire au management.</p>

                           <p><b>Qualités techniques requises :</b></p>

                           <ul>
                            <li>Bonne connaissance des technologies web et mobile</li>
                            <li>Bonne compréhension des langages de programmation (JavaScript, React, Typescript, MySql, etc.)</li>
                            <li>Expérience dans la résolution de problèmes techniques complexes</li>
                            <li>Expérience dans l'utilisation de Jira ou d'autres outils de gestion de tickets</li>
                            <li>Compréhension des principes de base de la gestion de base de données</li>
                           </ul>

                           <p><b>Qualités relationnelles requises :</b></p>

                           <ul>
                            <li>Excellentes compétences en communication écrite et verbale</li>
                            <li>Capacité à travailler en équipe et à collaborer avec des équipes multidisciplinaires</li>
                            <li>Bonne écoute et empathie envers les clients</li>
                            <li>Esprit de synthèse et capacité à gérer un tableau de bord</li>
                            <li>Capacité à travailler de manière autonome et à prendre des initiatives</li>
                           </ul>

                           <p><b>Profil recherché :</b></p>

                           <ul>
                            <li>Étudiant(e) en informatique ou en génie logiciel (Bac+4/5)</li>
                            <li>Expérience professionnelle ou de stage en tant que support technique ou dans un poste similaire</li>
                            <li>Capacité à travailler dans un environnement en évolution rapide</li>
                           </ul>

                            <p>Nous recherchons des alternants ou contrats pro : vous vous ferez une réelle place dans notre équipe, et nous aurons à coeur de vous accompagner dans votre parcours d'alternance.</p>

                            <a href="mailto:rh@agrivitech.com" class="btn btn-secondary m-5">Postuler</a>
                        </div>
                    </div>


                </div>
            </div>
        </div>


       
   </div>
</template>

<script >
export default {
    name: 'Jobs',
    components:{},
    props:{}
}
</script>

<style lang="scss" scoped>


.intro{
    margin-bottom: 20px;
    font-weight: 500;
    color: grey;
    line-height: 25px;
    padding: 20px;
    background-color: #f0f0f0;
    border-radius: 8px;
    .bleu{
        color: var(--mainBlue);
    }
}
// .tab-content{
//     height: 70vh;
//     overflow: scroll;
//     overflow-x: hidden;
// }
.card{
    // border-radius: 12px;
    border: none;
    padding: 20px 40px;
    .title{
        text-align: left!important;
    }
}

.backGreen{
        background-color: var(--mainGreen);
        font-weight: 700;
        font-size: 20px;
    }


.nav-pills{
    a{
        color: var(--mainBlue)!important;
        font-size: 16px;
        font-weight: 600;
        background-color: #f9f9f9;
        margin-bottom: 10px;
    }
    .active{
        background-color: var(--mainGreen)!important;
        color: white!important;
    }
}
@media (max-width: 768px) {

        .nav-pills a{
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
            
    }

</style>